// mockBuilderDetails.ts - Sample data for builder project details form
import sampleImage from "@/assets/sample-project.webp";

interface ProjectImage {
  id: string;
  url: string;
  description?: string;
}

export interface BuilderDetails {
  // Project Information
  id: number;
  projectName: string;
  jobType: string;
  completedYear: number;
  projectAddress: string;
  city: string;
  latitude: number;
  longitude: number;

  // Builder Information
  builderName: string;
  builderPhone: string;
  builderEmail: string;
  builderWebsite: string;

  // Project Images
  projectImages: ProjectImage[];
}

export const ProjectTypes = [
  { id: 1, name: "Roofing" },
  { id: 2, name: "Construction" },
  { id: 3, name: "Renovation" },
];
export const CompletionYear = [
  { id: 1, name: "2022" },
  { id: 2, name: "2023" },
  { id: 3, name: "2024" },
];
export const ProjectLocations = [
  { id: 1, name: "Vancouver" },
  { id: 2, name: "British Columbia" },
  { id: 3, name: "Toronto" },
];

// Sample data array with multiple builder projects
export const mockBuilderProjects: BuilderDetails[] = [
  {
    id: 11,
    projectName: "Oceanview Residences",
    jobType: "Residential Complex",
    completedYear: 2023,
    projectAddress: "1234 Coastal Highway",
    city: "West Vancouver, British Columbia",
    latitude: 34.0259,
    longitude: -118.7798,

    builderName: "Seaside Construction Inc.",
    builderPhone: "(310) 555-7890",
    builderEmail: "info@seasideconstruction.com",
    builderWebsite: "https://www.seasideconstruction.com",

    projectImages: [
      {
        id: "img1",
        url: sampleImage,
        description: "Front view of Oceanview Residences",
      },
      {
        id: "img2",
        url: sampleImage,
        description: "Main lobby interior",
      },
      {
        id: "img3",
        url: sampleImage,
        description: "Community pool area",
      },
    ],
  },
  {
    id: 22,
    projectName: "Downtown Business Center",
    jobType: "Commercial Office",
    completedYear: 2022,
    projectAddress: "567 Market Street",
    city: "West Vancouver, British Columbia",
    latitude: 37.7749,
    longitude: -122.4194,

    builderName: "Urban Development LLC",
    builderPhone: "(415) 555-1234",
    builderEmail: "contact@urbandevelopment.com",
    builderWebsite: "https://www.urbandevelopment.com",

    projectImages: [
      {
        id: "img1",
        url: sampleImage,
        description: "Exterior of Downtown Business Center",
      },
      {
        id: "img2",
        url: sampleImage,
        description: "Open plan office spaces",
      },
    ],
  },
  {
    id: 33,
    projectName: "Green Valley Elementary School",
    jobType: "Educational Institution",
    completedYear: 2024,
    projectAddress: "890 Valley Road",
    city: "West Vancouver, British Columbia",
    latitude: 45.5152,
    longitude: -122.6784,

    builderName: "EduBuild Solutions",
    builderPhone: "(503) 555-9876",
    builderEmail: "projects@edubuild.com",
    builderWebsite: "https://www.edubuildsolutions.com",

    projectImages: [
      {
        id: "img1",
        url: sampleImage,
        description: "Main entrance of Green Valley Elementary",
      },
      {
        id: "img2",
        url: sampleImage,
        description: "Sustainable playground facilities",
      },
      {
        id: "img3",
        url: sampleImage,
        description: "Modern classroom design",
      },
    ],
  },
];

// Default export for the mock data
export default mockBuilderProjects;
